(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 85392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _theme_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82681);
/* harmony import */ var _useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58491);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/**
 * Can't use the media queries from "base.mediaQueries" because of how matchMedia works
 * In order for the listener to trigger we need have have the media query with a range, e.g.
 * (min-width: 370px) and (max-width: 576px)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 */
var mediaQueries = function () {
  var prevMinWidth = 0;
  return Object.keys(_theme_base__WEBPACK_IMPORTED_MODULE_2__/* .breakpointMap */ ._E).reduce(function (accum, size, index) {
    // Largest size is just a min-width of second highest max-width
    if (index === Object.keys(_theme_base__WEBPACK_IMPORTED_MODULE_2__/* .breakpointMap */ ._E).length - 1) {
      return _objectSpread(_objectSpread({}, accum), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, size, "(min-width: ".concat(prevMinWidth, "px)")));
    }

    var minWidth = (prevMinWidth || 1) - 1;
    var breakpoint = _theme_base__WEBPACK_IMPORTED_MODULE_2__/* .breakpointMap */ ._E[size] - 1; // Min width for next iteration

    prevMinWidth = breakpoint + 1;
    return _objectSpread(_objectSpread({}, accum), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, size, "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(breakpoint, "px)")));
  }, {});
}();

var getKey = function getKey(size) {
  return "is".concat(size.charAt(0).toUpperCase()).concat(size.slice(1));
};

var getState = function getState() {
  var s = Object.keys(mediaQueries).reduce(function (accum, size) {
    var _mql$matches;

    var key = getKey(size);

    if (false) {}

    var mql = window.matchMedia(mediaQueries[size]);
    return _objectSpread(_objectSpread({}, accum), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, (_mql$matches = mql === null || mql === void 0 ? void 0 : mql.matches) !== null && _mql$matches !== void 0 ? _mql$matches : false));
  }, {});
  return s;
};

var useMatchBreakpoints = function useMatchBreakpoints() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function () {
    return getState();
  }),
      state = _useState[0],
      setState = _useState[1];

  (0,_useIsomorphicEffect__WEBPACK_IMPORTED_MODULE_3__/* .useIsomorphicEffect */ .Y)(function () {
    // Create listeners for each media query returning a function to unsubscribe
    var handlers = Object.keys(mediaQueries).map(function (size) {
      var mql = window.matchMedia(mediaQueries[size]);

      var handler = function handler(matchMediaQuery) {
        var key = getKey(size);
        setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, matchMediaQuery.matches));
        });
      }; // Safari < 14 fix


      if (mql.addEventListener) {
        mql.addEventListener('change', handler);
      }

      return function () {
        // Safari < 14 fix
        if (mql.removeEventListener) {
          mql.removeEventListener('change', handler);
        }
      };
    });
    setState(getState());
    return function () {
      handlers.forEach(function (unsubscribe) {
        unsubscribe();
      });
    };
  }, []);
  return _objectSpread(_objectSpread({}, state), {}, {
    isMobile: state.isXs || state.isSm,
    isTablet: state.isMd || state.isLg,
    isDesktop: state.isXl || state.isXxl || state.isXxxl
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useMatchBreakpoints);

/***/ }),

/***/ 9858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/layout/Components/Column.tsx
var Column = __webpack_require__(64533);
// EXTERNAL MODULE: ./src/components/Text/index.ts
var Text = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/components/Box/Grid.tsx
var Grid = __webpack_require__(65969);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 3 modules
var Image = __webpack_require__(15967);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(44785);
// EXTERNAL MODULE: ./src/config/constants/route.ts
var route = __webpack_require__(90381);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/layout/Components/HunnySocial.tsx








var HunnySocial = function HunnySocial() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      external: true,
      href: route/* RouteConfig.Twitter */.F.Twitter,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/social/twitter.png",
        width: 24,
        height: 25,
        alt: "icon-social-twitter"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      external: true,
      href: route/* RouteConfig.Telegram */.F.Telegram,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/social/telegram.png",
        width: 24,
        height: 25,
        alt: "icon-social-telegram"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      external: true,
      href: route/* RouteConfig.Medium */.F.Medium,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/social/medium.png",
        width: 24,
        height: 25,
        alt: "icon-social-medium"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
      external: true,
      href: route/* RouteConfig.Discord */.F.Discord,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/social/discord.png",
        width: 24,
        height: 25,
        alt: "icon-social-discord"
      })
    })]
  });
};

var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
  displayName: "HunnySocial__StyledWrapper",
  componentId: "sc-ilexx2-0"
})(["\n  grid-gap: 16px;\n  padding: 8px;\n\n  background: #1c202e;\n  position: fixed;\n  top: 200px;\n  right: -10px;\n  width: 50px;\n  z-index: ", ";\n  border-radius: ", ";\n\n  svg {\n    max-height: 24px;\n    max-width: 24px;\n    width: 100%;\n    height: 100%;\n  }\n\n  ", " {\n    padding: 16px;\n    width: 70px;\n\n    svg {\n      max-height: 28px;\n      max-width: 28px;\n    }\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.zIndices.modal;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.large;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.md;
});
/* harmony default export */ var Components_HunnySocial = (HunnySocial);
// EXTERNAL MODULE: ./src/components/Box/Box.tsx
var Box = __webpack_require__(55704);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/Box/Flex.tsx
var Flex = __webpack_require__(26303);
// EXTERNAL MODULE: ./src/layout/Components/Row.tsx
var Row = __webpack_require__(78360);
// EXTERNAL MODULE: ./src/components/Button/Button.tsx + 3 modules
var Button = __webpack_require__(39281);
;// CONCATENATED MODULE: ./src/components/Button/PokerButton.tsx


var _excluded = ["children", "variant"];

var _varirantsTheme;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var VariantPokerButton;

(function (VariantPokerButton) {
  VariantPokerButton["OPEN_APP"] = "OPEN_APP";
  VariantPokerButton["APK"] = "APK";
  VariantPokerButton["SCAN"] = "SCAN";
  VariantPokerButton["WALLET"] = "WALLET";
  VariantPokerButton["BALANCE"] = "BALANCE";
})(VariantPokerButton || (VariantPokerButton = {}));

var varirantsTheme = (_varirantsTheme = {}, (0,defineProperty/* default */.Z)(_varirantsTheme, VariantPokerButton.OPEN_APP, {
  backgroundOutner: '#0D47A1',
  backgroundInner: 'linear-gradient(98.13deg, #2196F3 3.59%, #1565C0 70.34%)',
  ellipsebackground: '#0D47A1',
  borderGradient: '#1565C0'
}), (0,defineProperty/* default */.Z)(_varirantsTheme, VariantPokerButton.APK, {
  backgroundOutner: '#040404',
  backgroundInner: 'linear-gradient(91.34deg, #4B4747 -3.91%, #2D2C2C 102.6%)',
  ellipsebackground: '#201F1F',
  borderGradient: 'linear-gradient(180deg, #9F9F9F 0%, #444444 100%)'
}), (0,defineProperty/* default */.Z)(_varirantsTheme, VariantPokerButton.SCAN, {
  backgroundOutner: '#F07803',
  backgroundInner: 'linear-gradient(98.13deg, #F9DC26 3.59%, #FF8308 70.34%)',
  ellipsebackground: '#F07803',
  borderGradient: '#FBBB1B'
}), (0,defineProperty/* default */.Z)(_varirantsTheme, VariantPokerButton.WALLET, {
  backgroundOutner: '#FF4081',
  backgroundInner: 'linear-gradient(91.34deg, #F06292 -3.91%, #D81B60 102.6%) ',
  ellipsebackground: '#E91E63',
  borderGradient: 'linear-gradient(180deg, #F48FB1 0%, #F06292 100%)'
}), (0,defineProperty/* default */.Z)(_varirantsTheme, VariantPokerButton.BALANCE, {
  backgroundOutner: '#37474f',
  backgroundInner: '#37474F',
  ellipsebackground: '#37474f',
  borderGradient: '#34434a'
}), _varirantsTheme);

var PokerButton = function PokerButton(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? VariantPokerButton.APK : _ref$variant,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var varianStyled = varirantsTheme[variant];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, _objectSpread(_objectSpread({
    variant: varianStyled
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BoxGradient, {
      variant: varianStyled,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledContaiener, {
        variant: varianStyled,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledContent, {
          children: children
        })
      })
    })
  }));
};

var BoxGradient = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PokerButton__BoxGradient",
  componentId: "sc-3lrrir-0"
})(["\n  width: inherit;\n  box-sizing: border-box;\n  height: calc(100% - 2px);\n  transition: 0.2s all;\n  background: ", ";\n  border-radius: 10px;\n  padding: 2px;\n\n  ", " {\n    border-radius: 25px;\n    height: calc(100% - 6px);\n  }\n"], function (_ref2) {
  var variant = _ref2.variant;
  return variant.borderGradient;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.xl;
});
var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Row/* RowMiddle */._B).withConfig({
  displayName: "PokerButton__StyledContent",
  componentId: "sc-3lrrir-1"
})(["\n  color: #fff;\n"]);
var StyledContaiener = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "PokerButton__StyledContaiener",
  componentId: "sc-3lrrir-2"
})(["\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  padding: 0 12px;\n\n  z-index: 2;\n  position: relative;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transition: 0.4s all;\n  background: ", ";\n\n  &:before {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    content: ' ';\n\n    transform: Translate(-25%, 30%);\n    width: 200%;\n    height: 100%;\n    z-index: 0;\n    background: ", ";\n    clip-path: ellipse(27% 40% at 50% 50%);\n  }\n\n  ", " {\n    position: relative;\n    z-index: 1000;\n  }\n\n  ", " {\n    border-radius: 23px;\n  }\n"], function (_ref4) {
  var variant = _ref4.variant;
  return variant.backgroundInner;
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant.ellipsebackground;
}, StyledContent, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.xl;
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "PokerButton__StyledButton",
  componentId: "sc-3lrrir-3"
})(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n\n  background: ", ";\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  transition: 0.2s all;\n\n  border-radius: 10px;\n  padding: 0;\n\n  ", " {\n    border-radius: 25px;\n  }\n"], function (_ref7) {
  var variant = _ref7.variant;
  return variant.backgroundOutner;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediaQueries.xl;
});
/* harmony default export */ var Button_PokerButton = (PokerButton);
// EXTERNAL MODULE: ./src/hooks/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(85392);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(49279);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/services/AuthenticationService.ts
var AuthenticationService = __webpack_require__(66475);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(13911);
// EXTERNAL MODULE: ./src/config/constants/server.ts
var server = __webpack_require__(25920);
// EXTERNAL MODULE: ./src/components/Link/Link.tsx
var Link_Link = __webpack_require__(38767);
// EXTERNAL MODULE: ./src/hooks/useActionQueryListener.ts
var useActionQueryListener = __webpack_require__(66064);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx
var Modal = __webpack_require__(20458);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(87625);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(84059);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(93955);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/components/Heading/index.ts
var Heading = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(95322);
// EXTERNAL MODULE: ./src/components/Modal/index.ts + 2 modules
var components_Modal = __webpack_require__(67498);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx + 1 modules
var Text_Text = __webpack_require__(50011);
// EXTERNAL MODULE: ./src/utils/dateHelper.ts
var dateHelper = __webpack_require__(46030);
;// CONCATENATED MODULE: ./src/views/Home/components/QRLoginApp.tsx



function QRLoginApp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function QRLoginApp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? QRLoginApp_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : QRLoginApp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























var QRLoginApp = function QRLoginApp(_ref) {
  var onDismiss = _ref.onDismiss;

  var _useAuth = (0,hooks/* useAuth */.aC)(),
      hasSession = _useAuth.hasSession;

  var router = (0,useRouter/* useRouter */.t)();

  var _useState = (0,react.useState)(''),
      tokenDeepLink = _useState[0],
      setTokenDeepLink = _useState[1];

  var _useState2 = (0,react.useState)(0),
      timeGenerateQR = _useState2[0],
      setTimeGenerateQR = _useState2[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _data$data;

    var data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return AuthenticationService/* default.getDeepLinkToken */.Z.getDeepLinkToken();

          case 2:
            data = _context.sent;
            setTokenDeepLink((data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.token) || '');
            setTimeGenerateQR((0,dateHelper/* getNextSeconds */.eC)(1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  (0,react.useEffect)(function () {
    if (hasSession) {
      fetchData();
    } else {
      router.push({
        pathname: router.pathname,
        query: QRLoginApp_objectSpread(QRLoginApp_objectSpread({}, router.query), {}, {
          action: useActionQueryListener/* ActionQueryEnum.Login */.Vt.Login
        })
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [hasSession]);
  var resendCodeTextRef = (0,useCountdown/* useCountDown */.h)(timeGenerateQR, function (s) {
    return "00:".concat(s.toString().padStart(2, '0'));
  }, function () {
    fetchData();
  });
  var renderQRCode = (0,react.useMemo)(function () {
    return tokenDeepLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledQRCode, {
      value: tokenDeepLink
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* RowCenter */.K7, {
      width: "100%",
      height: "100%",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {})
    });
  }, [tokenDeepLink]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
    onDismiss: onDismiss,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Modal/* ModalHeader */.xB, {
      px: ['12px', '', '24px'],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* Trans */.c, {
          children: "Scan QR Code to Login on App"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_Modal/* ModalBody */.fe, {
      p: ['12px', '', '24px'],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Column/* ColumnCenter */.lg, {
        my: "24px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledContainerQRCode, {
          children: renderQRCode
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
          fontWeight: 700,
          mt: "12px",
          fontSize: ['14px', '', '16px'],
          ref: resendCodeTextRef,
          children: "..."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        maxWidth: "90%",
        mx: "auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledStep, {
          children: ["Step 1: Install the \u201CHunnyPoker\u201D app on your mobile device. You can download it", /*#__PURE__*/(0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
            fontWeight: 600,
            color: "#cb00ff",
            ml: "4px",
            href: server/* APK_URL */.hr,
            external: true,
            style: {
              display: 'inline-block'
            },
            children: "here"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStep, {
          children: "Step 2: Open the HunnyPoker app, go to the \u201CWallet\u201D tab, and click on the \u201CScan QR code\u201D button."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStep, {
          children: "Step 3: Scan the QR code above to log in to your account on that device."
        })]
      })]
    })]
  });
};

var StyledContainerQRCode = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "QRLoginApp__StyledContainerQRCode",
  componentId: "sc-1yap3yr-0"
})(["\n  padding: 12px;\n  background: #fff;\n  border-radius: ", ";\n\n  width: 240px !important;\n  height: 240px !important;\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.small;
});
var StyledQRCode = (0,styled_components_browser_esm/* default */.ZP)(esm/* default */.ZP).withConfig({
  displayName: "QRLoginApp__StyledQRCode",
  componentId: "sc-1yap3yr-1"
})(["\n  width: 100% !important;\n  height: 100% !important;\n"]);
var StyledStep = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
  displayName: "QRLoginApp__StyledStep",
  componentId: "sc-1yap3yr-2"
})(["\n  font-size: 14px;\n  line-height: 20px;\n  margin: 6px 0;\n  color: ", ";\n\n  padding-left: 16px;\n  position: relative;\n  &::before {\n    content: '\u2022'; /* the dot */\n    font-size: 2.2em;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translateY(-15%);\n  }\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text;
});
/* harmony default export */ var components_QRLoginApp = (QRLoginApp);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./src/hooks/usePlayGame.tsx
var usePlayGame = __webpack_require__(90963);
;// CONCATENATED MODULE: ./src/components/Button/PlayNowButton.tsx


var PlayNowButton_excluded = ["variant", "fontSize", "lineHeight"];

var _PlayNowButtonTheme$D;

function PlayNowButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlayNowButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlayNowButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlayNowButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var PlayNowButtonTheme;

(function (PlayNowButtonTheme) {
  PlayNowButtonTheme["DEFAULT"] = "DEFAULT";
})(PlayNowButtonTheme || (PlayNowButtonTheme = {}));

var StatusButton;

(function (StatusButton) {
  StatusButton["default"] = "default";
  StatusButton["hover"] = "hover";
  StatusButton["active"] = "active";
})(StatusButton || (StatusButton = {}));

var variants = (0,defineProperty/* default */.Z)({}, PlayNowButtonTheme.DEFAULT, (_PlayNowButtonTheme$D = {}, (0,defineProperty/* default */.Z)(_PlayNowButtonTheme$D, StatusButton["default"], {
  boxShadow: 'rgba(144, 117, 242, 0.5)',
  backgroundOutner: '#0072ff',
  backgroundInner: '#f6f5ff',
  borderGradient: 'linear-gradient(180deg, #dbfffe 0%, #25dfff 100%), linear-gradient(0deg, #f6f5ff, #f6f5ff)',
  ellipsebackground: '#d1cef5',
  textButton: '#291ab4'
}), (0,defineProperty/* default */.Z)(_PlayNowButtonTheme$D, StatusButton.hover, {
  boxShadow: 'rgba(136, 177, 244, 0.5)',
  backgroundOutner: '#89E2FF',
  backgroundInner: '#f6f5ff',
  borderGradient: '#89E2FF',
  ellipsebackground: 'transparent',
  textButton: '#291ab4'
}), (0,defineProperty/* default */.Z)(_PlayNowButtonTheme$D, StatusButton.active, {
  boxShadow: 'rgba(91, 222, 192, 0.6)',
  backgroundOutner: '#FF9804',
  backgroundInner: '#FFFFE3',
  borderGradient: 'linear-gradient(180deg, #DEFF00 0%, #FEDF00 100%)',
  ellipsebackground: '#FFFEB3',
  textButton: '#EA7800'
}), _PlayNowButtonTheme$D));

var PlayNowButton = function PlayNowButton(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? PlayNowButtonTheme.DEFAULT : _ref$variant,
      fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, PlayNowButton_excluded);

  var varianStyled = variants[variant];
  var handlePlayGame = (0,usePlayGame/* usePlayGame */.y)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PlayNowButton_StyledButton, PlayNowButton_objectSpread(PlayNowButton_objectSpread({
    variant: varianStyled,
    onClick: handlePlayGame
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlayNowButton_BoxGradient, {
      variant: varianStyled,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlayNowButton_StyledContaiener, {
        variant: varianStyled,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
          mt: ['0', '', '', '8px'],
          whiteSpace: "nowrap",
          fontFamily: "Martel",
          textAlign: "center",
          fontWeight: 900,
          fontSize: fontSize || ['20px', '', '28px', '34px', '46px'],
          lineHeight: lineHeight || ['20px', '', '28px', '34px', '46px'],
          children: "PLAY NOW!"
        })
      })
    })
  }));
};

var BoxRadiusOutner = (0,styled_components_browser_esm/* css */.iv)(["\n  border-radius: 25px;\n\n  ", " {\n    border-radius: 35px;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.sm;
});
var BoxRadiusInner = (0,styled_components_browser_esm/* css */.iv)(["\n  border-radius: 22px;\n\n  ", " {\n    border-radius: 32px;\n  }\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.md;
});
var PlayNowButton_BoxGradient = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PlayNowButton__BoxGradient",
  componentId: "sc-18mclqt-0"
})(["\n  width: inherit;\n  box-sizing: border-box;\n  height: calc(100% - 4px);\n  background: ", ";\n  padding: 3px;\n\n  ", " {\n    height: calc(100% - 6px);\n  }\n\n  ", " {\n    height: calc(100% - 12px);\n  }\n\n  ", "\n"], function (_ref4) {
  var variant = _ref4.variant;
  return variant["default"].borderGradient;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.sm;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.md;
}, BoxRadiusOutner);
var PlayNowButton_StyledContaiener = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
  displayName: "PlayNowButton__StyledContaiener",
  componentId: "sc-18mclqt-1"
})(["\n  width: 100%;\n  height: 100%;\n\n  z-index: 2;\n  position: relative;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transition: 0.4s all;\n  background: ", ";\n  padding: 0 24px;\n\n  &:before {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    content: ' ';\n\n    transform: Translate(-25%, 30%);\n    width: 200%;\n    height: 100%;\n    z-index: 1;\n    background: ", ";\n    /* box-shadow: 0px -8px 10px 12px rgba(144, 117, 242, 0.5); */\n    clip-path: ellipse(27% 35% at 50% 50%);\n  }\n\n  ", " {\n    position: relative;\n    z-index: 1000;\n    color: ", ";\n  }\n\n  ", " {\n    padding: 0 40px;\n  }\n\n  ", "\n"], function (_ref7) {
  var variant = _ref7.variant;
  return variant["default"].backgroundInner;
}, function (_ref8) {
  var variant = _ref8.variant;
  return variant["default"].ellipsebackground;
}, Text_Text/* default */.Z, function (_ref9) {
  var variant = _ref9.variant;
  return variant["default"].textButton;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.mediaQueries.sm;
}, BoxRadiusInner);
var PlayNowButton_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "PlayNowButton__StyledButton",
  componentId: "sc-18mclqt-2"
})(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n\n  box-shadow: 0px -8px 8px 2px ", ";\n  background: ", ";\n  width: ", ";\n  height: height;\n  overflow: hidden;\n  transition: 0.2s all;\n\n  padding: 0;\n\n  ", " {\n    box-shadow: 0px -8px 10px 12px ", ";\n  }\n\n  ", " {\n    box-shadow: 0px -8px 10px 12px ", ";\n  }\n\n  ", " {\n    &:hover {\n      box-shadow: 0px -8px 10px 12px ", ";\n      background: ", ";\n\n      ", " {\n        background: ", ";\n        box-shadow: 0px 10px 14px -16px #000;\n      }\n\n      ", " {\n        background: ", ";\n\n        &:before {\n          transition: 0.2s all;\n          background: ", ";\n        }\n\n        ", " {\n          color: ", ";\n        }\n      }\n    }\n\n    &:active {\n      box-shadow: 0px -8px 10px 12px ", ";\n      background: ", ";\n\n      ", " {\n        background: ", ";\n        box-shadow: 0px 10px 14px -16px #000;\n      }\n\n      ", " {\n        background: ", ";\n\n        &:before {\n          transition: 0.2s all;\n          background: ", ";\n        }\n        ", " {\n          color: ", ";\n        }\n      }\n    }\n  }\n\n  ", "\n"], function (_ref11) {
  var variant = _ref11.variant;
  return variant["default"].boxShadow;
}, function (_ref12) {
  var variant = _ref12.variant;
  return variant["default"].backgroundOutner;
}, function (_ref13) {
  var width = _ref13.width;
  return width || '100%';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.mediaQueries.md;
}, function (_ref15) {
  var variant = _ref15.variant;
  return variant["default"].boxShadow;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.mediaQueries.md;
}, function (_ref17) {
  var variant = _ref17.variant;
  return variant["default"].boxShadow;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.mediaQueries.xl;
}, function (_ref19) {
  var variant = _ref19.variant;
  return variant.hover.boxShadow;
}, function (_ref20) {
  var variant = _ref20.variant;
  return variant.hover.backgroundOutner;
}, PlayNowButton_BoxGradient, function (_ref21) {
  var variant = _ref21.variant;
  return variant.hover.borderGradient;
}, PlayNowButton_StyledContaiener, function (_ref22) {
  var variant = _ref22.variant;
  return variant.hover.backgroundInner;
}, function (_ref23) {
  var variant = _ref23.variant;
  return variant.hover.ellipsebackground;
}, Text_Text/* default */.Z, function (_ref24) {
  var variant = _ref24.variant;
  return variant.hover.textButton;
}, function (_ref25) {
  var variant = _ref25.variant;
  return variant.active.boxShadow;
}, function (_ref26) {
  var variant = _ref26.variant;
  return variant.active.backgroundOutner;
}, PlayNowButton_BoxGradient, function (_ref27) {
  var variant = _ref27.variant;
  return variant.active.borderGradient;
}, PlayNowButton_StyledContaiener, function (_ref28) {
  var variant = _ref28.variant;
  return variant.active.backgroundInner;
}, function (_ref29) {
  var variant = _ref29.variant;
  return variant.active.ellipsebackground;
}, Text_Text/* default */.Z, function (_ref30) {
  var variant = _ref30.variant;
  return variant.active.textButton;
}, BoxRadiusOutner);
/* harmony default export */ var Button_PlayNowButton = (PlayNowButton);
;// CONCATENATED MODULE: ./src/views/Home/components/PlayNow.tsx



function PlayNow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlayNow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlayNow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlayNow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var PlayNow = function PlayNow(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(PlayNow_StyledWrapper, PlayNow_objectSpread(PlayNow_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_PlayNowButton, {
      width: "100%",
      height: ['60px', '', '100px']
    })
  }));
};

var PlayNow_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
  displayName: "PlayNow__StyledWrapper",
  componentId: "sc-5ehq8a-0"
})(["\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, 0);\n\n  max-width: 160px;\n\n  a {\n    width: 100%;\n  }\n\n  ", " {\n    max-width: 320px;\n  }\n\n  ", " {\n    position: relative;\n    top: unset;\n    left: unset;\n    transform: unset;\n    bottom: unset;\n    left: unset;\n    transform: unset;\n    max-width: 100%;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.sm;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.lg;
});
/* harmony default export */ var components_PlayNow = (PlayNow);
;// CONCATENATED MODULE: ./src/views/Home/components/HomeBottom.tsx





function HomeBottom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HomeBottom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HomeBottom_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HomeBottom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var HomeBottom = function HomeBottom() {
  var router = (0,useRouter/* useRouter */.t)();
  var clubCode = router.query.club;

  var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(),
      isDesktop = _useMatchBreakpoints.isDesktop;

  var _useModal = (0,useModal/* default */.Z)(components_QRLoginApp),
      _useModal2 = (0,slicedToArray/* default */.Z)(_useModal, 1),
      onPresentQR = _useModal2[0];

  var isSigned = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.isSigned;
  });

  var handleRedirectIntoGame = function handleRedirectIntoGame() {
    router.push('/play', {
      query: {
        club: clubCode
      }
    });
  };

  (0,react.useEffect)(function () {
    if (clubCode && isSigned) {
      handleRedirectIntoGame();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isSigned]);
  var handleOpenApp = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _result$data;

    var result, paramsClubCode;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isSigned) {
              _context.next = 3;
              break;
            }

            router.push({
              pathname: router.pathname,
              query: HomeBottom_objectSpread(HomeBottom_objectSpread({}, router.query || {}), {}, {
                action: useActionQueryListener/* ActionQueryEnum.Login */.Vt.Login
              })
            });
            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return AuthenticationService/* default.getDeepLinkToken */.Z.getDeepLinkToken();

          case 5:
            result = _context.sent;

            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.token) {
              paramsClubCode = clubCode ? "&ClubCode".concat(clubCode) : '';
              window.open("unitydl://mylink?".concat(result.data.token).concat(paramsClubCode), '_blank');
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [clubCode, isSigned, router]);

  var handlePresentQRCode = function handlePresentQRCode() {
    if (!isSigned) {
      router.push({
        pathname: router.pathname,
        query: HomeBottom_objectSpread(HomeBottom_objectSpread({}, router.query || {}), {}, {
          action: useActionQueryListener/* ActionQueryEnum.Login */.Vt.Login
        })
      });
      return;
    }

    onPresentQR();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(components_PlayNow, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(HomeBottom_StyledWrapper, {
      children: [isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(components_PlayNow, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapListButton, {
        children: [!lib/* isIOS */.gn && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [lib/* isMobile */.tq && !lib/* isIOS */.gn && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonOpenApp, {
            variant: VariantPokerButton.OPEN_APP,
            onClick: handleOpenApp,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/open-app.png",
              alt: "icon-open-app"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
              children: "Open App"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
            href: server/* APK_URL */.hr,
            external: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonDownload, {
              variant: VariantPokerButton.APK,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/android.png",
                alt: "icon-android"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
                children: "Direct APK Download"
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonScan, {
          variant: VariantPokerButton.SCAN,
          onClick: handlePresentQRCode,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/scan.png",
            alt: "icon-scan"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
            children: "Scan QR to login on App"
          })]
        })]
      })]
    })]
  });
};

var HomeBottom_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "HomeBottom__StyledWrapper",
  componentId: "sc-tuvxeo-0"
})(["\n  position: absolute;\n  bottom: 32px;\n  right: 16px;\n\n  ", " {\n    bottom: 60px;\n    right: 100px;\n  }\n\n  ", " {\n    bottom: 100px;\n    right: 140px;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.lg;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.xl;
});
var StyledWrapListButton = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
  displayName: "HomeBottom__StyledWrapListButton",
  componentId: "sc-tuvxeo-1"
})(["\n  margin-left: auto;\n  width: fit-content;\n\n  grid-template-columns: 1fr;\n\n  grid-gap: 10px;\n  margin-top: 48px;\n\n  ", " {\n    grid-gap: 20px;\n    margin-top: 48px;\n  }\n\n  ", " {\n    grid-template-columns: 1fr 1fr;\n  }\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediaQueries.lg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.lg;
});
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "HomeBottom__StyledText",
  componentId: "sc-tuvxeo-2"
})(["\n  text-align: center;\n  margin: 0 auto;\n  font-weight: 700;\n\n  font-size: 12px;\n  line-height: 18px;\n  padding-left: 4px;\n  margin: 0 auto;\n\n  ", " {\n    padding-left: 14px;\n  }\n\n  ", " {\n    font-size: 14px;\n  }\n\n  ", " {\n    padding: 0 16px;\n    font-size: 16px;\n  }\n  ", " {\n    font-size: 20px;\n\n    line-height: 24px;\n    margin-left: 0;\n    padding: 0 16px;\n  }\n"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.md;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediaQueries.lg;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.mediaQueries.xl;
});
var HomeBottom_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_PokerButton).withConfig({
  displayName: "HomeBottom__StyledButton",
  componentId: "sc-tuvxeo-3"
})(["\n  box-sizing: border-box;\n\n  width: 160px;\n  height: 50px;\n\n  img {\n    max-height: 24px;\n  }\n\n  ", " {\n    width: 160px;\n\n    img {\n      max-height: 30px;\n    }\n  }\n\n  ", " {\n    width: 200px;\n    height: 60px;\n    img {\n      max-height: 35px;\n    }\n  }\n\n  ", " {\n    width: 240px;\n    height: 80px;\n    img {\n      max-height: 40px;\n    }\n  }\n"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.mediaQueries.sm;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.mediaQueries.md;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.mediaQueries.xl;
});
var StyledButtonOpenApp = (0,styled_components_browser_esm/* default */.ZP)(HomeBottom_StyledButton).withConfig({
  displayName: "HomeBottom__StyledButtonOpenApp",
  componentId: "sc-tuvxeo-4"
})([""]);
var StyledButtonDownload = (0,styled_components_browser_esm/* default */.ZP)(HomeBottom_StyledButton).withConfig({
  displayName: "HomeBottom__StyledButtonDownload",
  componentId: "sc-tuvxeo-5"
})([""]);
var StyledButtonScan = (0,styled_components_browser_esm/* default */.ZP)(HomeBottom_StyledButton).withConfig({
  displayName: "HomeBottom__StyledButtonScan",
  componentId: "sc-tuvxeo-6"
})([""]);
/* harmony default export */ var components_HomeBottom = (HomeBottom);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(33731);
;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.tsx



var Carousel_excluded = ["current", "slides", "onSwiper", "modules", "thumbs", "slidesPerView", "autoplay", "pagination", "loop", "controller", "effect", "onActiveSlideChange", "spaceBetween"];

function Carousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Carousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Carousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Carousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // Import Swiper styles






var Carousel = function Carousel(_ref) {
  var current = _ref.current,
      slides = _ref.slides,
      _ref$onSwiper = _ref.onSwiper,
      _onSwiper = _ref$onSwiper === void 0 ? function () {} : _ref$onSwiper,
      _ref$modules = _ref.modules,
      modules = _ref$modules === void 0 ? [] : _ref$modules,
      thumbs = _ref.thumbs,
      slidesPerView = _ref.slidesPerView,
      _ref$autoplay = _ref.autoplay,
      autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
      _ref$pagination = _ref.pagination,
      pagination = _ref$pagination === void 0 ? false : _ref$pagination,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      controller = _ref.controller,
      effect = _ref.effect,
      onActiveSlideChange = _ref.onActiveSlideChange,
      _ref$spaceBetween = _ref.spaceBetween,
      spaceBetween = _ref$spaceBetween === void 0 ? 0 : _ref$spaceBetween,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Carousel_excluded);

  var controlledRef = (0,react.useRef)((thumbs === null || thumbs === void 0 ? void 0 : thumbs.swiper) || null);

  var _useState = (0,react.useState)(0),
      activeSlide = _useState[0],
      setActiveSlide = _useState[1];

  var handleStopAutoPlay = function handleStopAutoPlay() {
    var _controlledRef$curren, _controlledRef$curren2;

    if (typeof ((_controlledRef$curren = controlledRef.current) === null || _controlledRef$curren === void 0 ? void 0 : (_controlledRef$curren2 = _controlledRef$curren.autoplay) === null || _controlledRef$curren2 === void 0 ? void 0 : _controlledRef$curren2.stop) === 'function' && autoplay) {
      controlledRef.current.autoplay.stop();
    }
  };

  var handleStartAutoPlay = function handleStartAutoPlay() {
    var _controlledRef$curren3, _controlledRef$curren4;

    if (typeof ((_controlledRef$curren3 = controlledRef.current) === null || _controlledRef$curren3 === void 0 ? void 0 : (_controlledRef$curren4 = _controlledRef$curren3.autoplay) === null || _controlledRef$curren4 === void 0 ? void 0 : _controlledRef$curren4.start) === 'function' && autoplay) {
      controlledRef.current.autoplay.start();
    }
  };

  return slides && /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, Carousel_objectSpread(Carousel_objectSpread({}, props), {}, {
    onMouseOver: handleStopAutoPlay,
    onMouseOut: handleStartAutoPlay,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StypedSwiper, {
        spaceBetween: spaceBetween,
        onSwiper: function onSwiper(swiper) {
          controlledRef.current = swiper;

          if (_onSwiper) {
            _onSwiper(swiper);
          }
        },
        effect: effect,
        autoplay: autoplay,
        thumbs: thumbs,
        pagination: pagination,
        modules: [swiper_esm/* Controller */.Qr, swiper_esm/* Autoplay */.pt].concat((0,toConsumableArray/* default */.Z)(modules)),
        slidesPerView: slidesPerView,
        loop: loop,
        onSlideChange: function onSlideChange(swiper) {
          var index = swiper.realIndex;
          setActiveSlide(index);

          if (onActiveSlideChange) {
            onActiveSlideChange(index);
          }
        },
        children: slides.map(function (slide) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: slide.content
          }, slide.key);
        })
      })
    }), pagination && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaginationContainer, {
      children: slides.map(function (slide, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaginationButton, {
          $Active: index === activeSlide,
          onClick: function onClick() {
            return loop ? controlledRef.current.slideToLoop(index) : controlledRef.current.slideTo(index);
          }
        }, slide.key);
      })
    })]
  }));
};

var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Carousel__Wrapper",
  componentId: "sc-12gg9w9-0"
})(["\n  position: relative;\n  width: inherit;\n"]);
var Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Carousel__Container",
  componentId: "sc-12gg9w9-1"
})(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"]);
var StypedSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
  displayName: "Carousel__StypedSwiper",
  componentId: "sc-12gg9w9-2"
})(["\n  width: 100%;\n  height: 100%;\n"]);
var StyledPaginationContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Carousel__StyledPaginationContainer",
  componentId: "sc-12gg9w9-3"
})(["\n  position: absolute;\n  bottom: -16px;\n  right: 12px;\n  z-index: 2;\n\n  display: flex;\n"]);
var StyledPaginationButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Carousel__StyledPaginationButton",
  componentId: "sc-12gg9w9-4"
})(["\n  width: 6px;\n  height: 6px;\n  margin-left: 2px;\n  border-radius: 6px;\n  background: ", ";\n\n  transition: 0.2s;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n  }\n\n  ", ";\n\n  ", " {\n    width: 8px;\n    height: 8px;\n    margin-left: 4px;\n    border-radius: 8px;\n\n    ", ";\n  }\n"], function (_ref2) {
  var theme = _ref2.theme,
      $Active = _ref2.$Active;
  return $Active ? theme.colors.text : theme.colors.textDisable;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text;
}, function (_ref4) {
  var $Active = _ref4.$Active;
  return $Active ? (0,styled_components_browser_esm/* css */.iv)(["\n          width: 20px;\n        "]) : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.sm;
}, function (_ref6) {
  var $Active = _ref6.$Active;
  return $Active ? (0,styled_components_browser_esm/* css */.iv)(["\n            width: 22px;\n          "]) : '';
});
/* harmony default export */ var Carousel_Carousel = (Carousel);
;// CONCATENATED MODULE: ./src/views/Home/components/GameGrallery.tsx



function GameGrallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GameGrallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GameGrallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GameGrallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var GameGrallery = function GameGrallery(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(),
      isMobile = _useMatchBreakpoints.isMobile;

  var banners = (0,react.useMemo)(function () {
    return ['/images/grallery/grallery-1.png', '/images/grallery/grallery-2.png', '/images/grallery/grallery-3.png', '/images/grallery/grallery-4.png', '/images/grallery/grallery-5.png'].map(function (src, index) {
      return {
        key: "grallery-".concat(index),
        content: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapImage, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: src,
            width: 640,
            height: 1138,
            alt: "image-grallery"
          })
        })
      };
    });
  }, []);
  var renderQuality = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* default */.Z, {
      src: "/images/poker-quality.png",
      width: !isMobile ? 180 : 100,
      height: !isMobile ? 23 : 14
    });
  }, [isMobile]);
  var slidePerView = (0,react.useMemo)(function () {
    return isMobile ? 3 : 4;
  }, [isMobile]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GameGrallery_Wrapper, GameGrallery_objectSpread(GameGrallery_objectSpread({
    mb: ['-8px', '', '-60px', '', '-80px'],
    mx: "auto"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row/* RowCenter */.K7, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Column/* ColumnCenter */.lg, {
        children: [renderQuality, /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
          textAlign: "center",
          fontSize: ['10px', '12px', '', '16px', '24px', '30px'],
          lineHeight: ['18px', '', '24px', '32px', '36px'],
          fontWeight: 700,
          my: ['16px', '', '40px'],
          children: "WHY YOU SHOULD PLAY ON HUNNYPOKER"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_Carousel, {
      slidesPerView: slidePerView,
      pb: ["calc(17.78% * 10 / ".concat(slidePerView, " - 26px)")],
      spaceBetween: isMobile ? 10 : 20,
      slides: banners,
      loop: true,
      autoplay: {
        delay: 5000
      },
      pagination: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      mt: ['24px', '', '60px', '', '80px'],
      children: [renderQuality, " "]
    })]
  }));
};

var GameGrallery_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GameGrallery__Wrapper",
  componentId: "sc-cz01mb-0"
})(["\n  padding: 0 12px;\n  width: 100%;\n  overflow: hidden;\n  max-width: ", "px;\n\n  ", " {\n    padding: 0 24px;\n  }\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.siteWidth;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.sm;
});
var StyledWrapImage = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GameGrallery__StyledWrapImage",
  componentId: "sc-cz01mb-1"
})(["\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  scroll-snap-align: start;\n  scroll-snap-stop: normal;\n  border-radius: ", ";\n\n  ", " {\n    border-radius: ", ";\n  }\n"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.small;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radii.large;
});
/* harmony default export */ var components_GameGrallery = (GameGrallery);
;// CONCATENATED MODULE: ./src/views/Home/components/HomeFooter.tsx



function HomeFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HomeFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HomeFooter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HomeFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var HomeFooter = function HomeFooter(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BoxWrapper, HomeFooter_objectSpread(HomeFooter_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HomeFooter_StyledContent, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Column/* ColumnCenter */.lg, {
        width: "max-content !important",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
          letterSpacing: 0,
          fontSize: ['10px', '12px', '', '16px', '24px', '', '40px'],
          mb: ['12px', '24px', '', '32px', '', '40px', '', '80px'],
          fontWeight: 500,
          children: "Hurry and get in on the action!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_PlayNowButton, {
          fontSize: ['12px', '14px', '', '', '28px', '', '34px', '', '36px'],
          lineHeight: ['14px', '', '', '28px', '', '34px', '', '46px'],
          maxWidth: ['100px', '140px', '', '', '240px', '', '360px'],
          height: ['40px', '', '', '90px']
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
      fontSize: ['10px', '12px', '', '14px', '', '16px'],
      mt: ['10px', '', '', '-2%'],
      children: "Copyright \xA9 2022 HunnyPoker"
    })]
  }));
};

var BoxWrapper = (0,styled_components_browser_esm/* default */.ZP)(Row/* RowCenter */.K7).withConfig({
  displayName: "HomeFooter__BoxWrapper",
  componentId: "sc-1vkj9tq-0"
})(["\n  width: 100%;\n  height: 100%;\n  padding-top: 41.67%;\n  position: relative;\n  background-image: url('/images/footer.png');\n  background-size: 100% 100%;\n"]);
var HomeFooter_StyledContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "HomeFooter__StyledContent",
  componentId: "sc-1vkj9tq-1"
})(["\n  position: absolute;\n  top: 50%;\n  left: 30%;\n  transform: translate(-50%, -50%);\n"]);
/* harmony default export */ var components_HomeFooter = (HomeFooter);
;// CONCATENATED MODULE: ./src/views/Home/Home.tsx












var HomePage = function HomePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Home_StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Components_HunnySocial, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainerBanner, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapLogo, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledLogo, {
          src: "/images/logo-full.png"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeading, {
          children: "THE MOST ENGAGING AND FUN POKER GAME ON CHAIN!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_HomeBottom, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      py: ['24px', '', '40px'],
      width: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_GameGrallery, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_HomeFooter, {})]
    })]
  });
};

var Home_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
  displayName: "Home__StyledWrapper",
  componentId: "sc-1x9pzux-0"
})(["\n  width: 100%;\n  height: 100%;\n  background: #170e55;\n"]);
var StyledContainerBanner = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
  displayName: "Home__StyledContainerBanner",
  componentId: "sc-1x9pzux-1"
})(["\n  padding: calc(25px + ", " + var(--notification-bar-height)) 0 0;\n\n  background-image: url('/images/background.png');\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n\n  ", " {\n    min-height: 70vh;\n  }\n\n  @media (max-height: 700px) {\n    min-height: 100vh;\n  }\n\n  ", " {\n    min-height: 100vh;\n    padding: calc(25px + ", " + var(--notification-bar-height)) 64px;\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.topbarHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.xs;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.sm;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.topbarHeight;
});
var StyledLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Home__StyledLogo",
  componentId: "sc-1x9pzux-2"
})(["\n  width: 100%;\n  margin-bottom: 16px;\n\n  ", " {\n    margin-bottom: 32px;\n  }\n"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.md;
});
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "Home__StyledHeading",
  componentId: "sc-1x9pzux-3"
})(["\n  font-family: 'Montserrat';\n\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #e5e5e5;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n\n  ", " {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  ", " {\n    font-size: 24px;\n    line-height: 40px;\n  }\n"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.md;
});
var StyledWrapLogo = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
  displayName: "Home__StyledWrapLogo",
  componentId: "sc-1x9pzux-4"
})(["\n  max-width: 80%;\n\n  ", " {\n    max-width: 400px;\n  }\n\n  ", " {\n    max-width: 550px;\n  }\n"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediaQueries.sm;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.mediaQueries.md;
});
/* harmony default export */ var Home = (HomePage);
;// CONCATENATED MODULE: ./src/views/Home/index.ts

;// CONCATENATED MODULE: ./src/pages/index.tsx

var __N_SSG = true;
/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9858);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [714,287,757,80,441,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);